"use client";
import { useLoaderStore } from '../../store/localapi';
import styles from './GlobalLoader.module.css';

export const GlobalLoader = () => {
    const isLoading = useLoaderStore((state) => state.isLoading);

    if (!isLoading) {
        return null;
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.spinner}></div>
        </div>
    );
};